/**
 * BusterDrone — Generated by hearth-asset-pipeline
 * Furniture: 1×1 tiles
 * Generated: 2026-04-11T05:58:00.193Z
 *
 * This is a procedural isometric furniture renderer produced from a 3D model.
 * Integrates with Hearth's renderFurniture() dispatch and isoBox primitives.
 */

import { renderIsoAsset, type IsoAssetDef } from "../../render/iso-engine.js";

/** Furniture registry metadata */
export const BusterDrone_META = {
  id: "BusterDrone",
  name: "BusterDrone",
  tileWidth: 1,
  tileHeight: 1,
  isoWidth: 18,
  isoDepth: 18,
  canonicalRot: 0 as const,
  interactionAnchors: [
    { type: "use_point", localWx: 0, localWy: 0, elevation: 0, faceDir: "S" },
  ],
} as const;

/** Declarative asset definition — pure data, no rendering code */
export const BusterDrone_DEF: IsoAssetDef = {
  id: "BusterDrone",
  name: "BusterDrone",
  tile: [1, 1],
  geometry: { w: 32, d: 8, h: 13 },
  faces: {
    top: {
      base: "#bbbbbb",
      palette: ["#bbbbbb", "#747473", "#949493", "#6c6c6b", "#8c8c8c"],
      metalness: 0.75,
      roughness: 0.40,
      opacity: 1.00,
      emissive: "#ffffff",
      materialType: "metal",
      gradient: { stops: [[0.00, "#525250"], [0.33, "#6c6b69"], [0.67, "#6d6e6c"], [1.00, "#5f5f5f"]], strength: 0.141 },
      grain: { scale: 2.0, contrast: 0.300, angle: 0 },
      specular: { x: 0.50, y: 0.63, radius: 0.48, intensity: 0.63 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
    left: {
      base: "#1c1c1b",
      palette: ["#1c1c1b", "#242423", "#131312", "#343433", "#3c3c3b"],
      metalness: 0.65,
      roughness: 0.43,
      opacity: 1.00,
      materialType: "metal",
      gradient: { stops: [[0.00, "#2e2f2c"], [0.33, "#3f3f3d"], [0.67, "#302f2e"], [1.00, "#5f5f5e"]], strength: 0.696 },
      grain: { scale: 2.0, contrast: 0.300 },
      specular: { x: 0.49, y: 0.51, radius: 0.60, intensity: 0.80 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
    right: {
      base: "#6d6d6d",
      palette: ["#6d6d6d", "#252424", "#343434", "#2b2b2b", "#141414"],
      metalness: 0.75,
      roughness: 0.38,
      opacity: 1.00,
      materialType: "metal",
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
  },
  anchors: [
    { type: "use_point", wx: 0, wy: 0, elevation: 0, dir: "S" },
  ],
};

/**
 * Render BusterDrone via the shared isometric material engine.
 * Drop-in compatible with Hearth's renderFurniture() dispatch.
 */
export function renderBusterDrone(
  ctx: CanvasRenderingContext2D,
  screenX: number,
  screenY: number,
  direction: 0 | 1 | 2 | 3,
  state: Record<string, unknown>,
  time: number,
): void {
  renderIsoAsset(ctx, BusterDrone_DEF, screenX, screenY, direction, state, time);
}